import React, {useCallback, useEffect, useState} from "react";

import type {IAfterGuiAttachedParams, IDoesFilterPassParams} from "ag-grid-community";
import type {CustomFilterProps} from "ag-grid-react";
import {useGridFilter} from "ag-grid-react";
import {Button} from "react-bootstrap";
import {AdminUser} from "services/adminsService";

const OPTIONS = ["Да", "Нет"] as const;

const rowSuperAdminLabel = (data: AdminUser | undefined) =>
    data?.isSuperAdmin ? "Да" : "Нет";

export const AdminSuperAdminFilter = ({model, onModelChange}: CustomFilterProps) => {
    const [closeFilter, setCloseFilter] = useState<(() => void) | undefined>();
    const [selectedValues, setSelectedValues] = useState<string[] | null>(model);

    const doesFilterPass = useCallback(
        (params: IDoesFilterPassParams<AdminUser>) => {
            return (
                !!selectedValues &&
                selectedValues.includes(rowSuperAdminLabel(params.data))
            );
        },
        [selectedValues],
    );

    const afterGuiAttached = useCallback(
        ({hidePopup}: IAfterGuiAttachedParams) => {
            setCloseFilter(() => hidePopup);
        },
        [],
    );

    useGridFilter({
        doesFilterPass,
        afterGuiAttached,
    });

    useEffect(() => {
        setSelectedValues(model ?? []);
    }, [model]);

    const onClick = () => {
        closeFilter?.();
    };

    return (
        <div className="p-3 d-flex flex-column bg-white">
            <label className="fw-bold">Супер админ</label>
            <div className="col-sm-10 mt-2">
                {OPTIONS.map((v) => (
                    <div key={v} className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id={`super-admin-${v}`}
                            checked={selectedValues?.includes(v)}
                            onChange={() => {
                                const next = selectedValues?.includes(v)
                                    ? selectedValues.filter((x) => x !== v)
                                    : [...(selectedValues ?? []), v];
                                const agNext = next.length ? next : null;
                                setSelectedValues(agNext);
                                onModelChange(agNext);
                            }}
                        />
                        <label className="form-check-label" htmlFor={`super-admin-${v}`}>
                            {v === "Да" ? "Да 🌟" : v}
                        </label>
                    </div>
                ))}
            </div>
            <Button size="sm" variant="secondary" onClick={onClick} className="mt-2">
                Готово
            </Button>
        </div>
    );
};
